import { AbstractControl, ValidationErrors } from '@angular/forms';

export function setInValidControl(control: AbstractControl): void {
  if (control) {
    control.setErrors({ 'incorrect': true });
    control.markAsTouched();
  }
}

export function setValidControl(control: AbstractControl): void {
  if (control) {
    control.setErrors(null);
    control.markAsTouched();
    // control.updateValueAndValidity();
  }
}
